export default "__VITE_ASSET__B8tN1Bj8__"